import { createAsyncThunk } from '@reduxjs/toolkit';

import type { PreferencesData } from '@/types/notificationPreferences/types';

import { notificationPreferencesService, type CreateMuteInput } from './services';

export const fetchNotificationPreferences = createAsyncThunk(
  'notification-preferences/fetch',
  async () => notificationPreferencesService.fetch(),
);

export const patchNotificationPreferences = createAsyncThunk(
  'notification-preferences/patch',
  async (data: Partial<PreferencesData>) => notificationPreferencesService.patch(data),
);

export const createNotificationMute = createAsyncThunk(
  'notification-preferences/createMute',
  async (input: CreateMuteInput) => notificationPreferencesService.createMute(input),
);

export const deleteNotificationMute = createAsyncThunk(
  'notification-preferences/deleteMute',
  async (id: string) => {
    await notificationPreferencesService.deleteMute(id);
    return id;
  },
);
